import { type IProductID } from "../../models/nominals";
import { type AppDispatch } from "../../store/reducers";
import {
    parseSSRConcreteBundles,
    parseSSRFinancingPlans,
    parseSSRProductClass,
    parseSSRProducts,
    parseSSRPromoCards,
    parseSSRReviewsProducts,
    parseSSRUpsellInfoModals,
} from "../../utils/ssr-data-parsers";
// eslint-disable-next-line import/no-restricted-paths -- pre-existing cross-app dependency (Phase E exemption)
import { loadProductsByUUIDs } from "../reviews/thunks/loadProductsByUUIDs";
import {
    loadConcreteBundles,
    loadFinancingPlans,
    loadProducts,
    removeDiscontinuedProducts,
} from "./thunks";

export const prefillSSRStoreData = (
    dispatch: AppDispatch,
    data: {
        products_data: string;
        product_class_data: string;
        financing_plans_data: string;
        concrete_bundles_data: string;
        upsell_info_modals_data: string;
        promo_cards_data: string;
        reviews_products_data: string;
        initial_variant_id: IProductID | null;
        product_ids: readonly IProductID[];
    },
): void => {
    const products = removeDiscontinuedProducts(
        parseSSRProducts(data.products_data),
    );
    const productClass = parseSSRProductClass(data.product_class_data);
    const financingPlans = parseSSRFinancingPlans(data.financing_plans_data);
    const concreteBundles = parseSSRConcreteBundles(data.concrete_bundles_data);
    const upsellInfoModals = parseSSRUpsellInfoModals(
        data.upsell_info_modals_data,
    );
    const promoCards = parseSSRPromoCards(data.promo_cards_data);

    if (products.length > 0) {
        dispatch(
            loadProducts.fulfilled(
                {
                    rootProducts: products,
                    productClass: productClass,
                    initialVariantID: data.initial_variant_id,
                },
                "",
                { productIDs: data.product_ids },
            ),
        );
    }

    if (financingPlans.length > 0) {
        const productID = products[0]?.id ?? data.product_ids[0];
        dispatch(
            loadFinancingPlans.fulfilled([...financingPlans], "", {
                productID,
            }),
        );
    }

    if (
        concreteBundles.length > 0 ||
        upsellInfoModals.length > 0 ||
        promoCards.length > 0
    ) {
        const variantID = products[0]?.id ?? data.product_ids[0];
        dispatch(
            loadConcreteBundles.fulfilled(
                {
                    concreteBundles: concreteBundles,
                    upsellInfoModals: upsellInfoModals,
                    promoCards: promoCards,
                    selectedUpgradeID: null,
                },
                "",
                { variantID },
            ),
        );
    }

    // Pre-fill reviews products so the Configurator can display ratings
    // without a client-side API call (which races with ProductReviews SSR).
    const reviewsProducts = parseSSRReviewsProducts(data.reviews_products_data);
    if (reviewsProducts.length > 0) {
        dispatch(loadProductsByUUIDs.fulfilled(reviewsProducts, "", []));
    }
};
